import {
  globalAction,
  messageAction,
  callAction,
  onlineAction,
  profileAction,
  chatAction,
  livemonitorAction,
} from "../../store/action";
import socketTransport from "./socket.transport";
import LiveMonitor from "./livemonitor.service";
import sip from "../../lib/sip";
import { UserAgent } from "sip.js";
import { Alert } from "modules/common/utils";
import moment from "moment";
import CommonManager, { parseCheckLists } from "../../helpers/common";
import { removeElementById } from "../../modules/screens/chatscreen/utils";
import {
  addNewCustomer,
  getHistory,
  receiveMessage,
  resolveCustomer,
  disposeCustomer,
  changeLastMessage,
  receiveAgentAssistMessage,
  getAssistHistory
} from "./chat.service";
const commonManager = new CommonManager();
let mSocket = null;
let messageService = {
  emitSocketMessage: (type, messageData) => {
    if (mSocket && mSocket.emit && mSocket.connected) {
      mSocket.emit(type, messageData);
    } else {
      console.error("[emitSocketMessage]", "Socket Server is not connected");
    }
  },
  destroyPhone: (dispatch, type, data) => {
    sip.destroyPhone();
  },
  answerCall: () => {
    sip.accept();
  },
  rejectCall: () => {
    sip.reject();
  },
};
let liveMonitor = new LiveMonitor({
  emitSocketMessage: messageService.emitSocketMessage,
});
export default {
  emitSocketMessage: messageService.emitSocketMessage,

  /* dispatch dispatchReceivedMessage when new data is received */
  receiveSocketMessage: (dispatch, config) => {
    mSocket = new socketTransport(config);
    mSocket.subscriber(`connect`, (data) => {
      dispatch(messageAction.socketState({ isConnected: true }));
    });
    // mSocket.subscriber('connect', async data => {
    //   dispatch(messageAction.socketState({ isConnected: true }));
    // });
    mSocket.subscriber("disconnect", async (data) => {
      dispatch(messageAction.socketState({ isConnected: false }));
    });
    mSocket.subscriber("notification", async (data) => {
      if (data) dispatch(messageAction.dispatchReceivedMessage(data));
    });
    mSocket.subscriber("message-processor", async (data) => {
      if (data) dispatch(messageAction.dispatchReceivedMessage(data));
    });

    // dispatch(messageAction.socketState({ isConnected: true }));
  },
  destroySocket: () => {
    try {
      mSocket.destroy();
      mSocket.startSocketIO();
    } catch (error) {
      console.log(" destroySocket error", error);
    }
  },

  notificationSocketMessage: (
    dispatch,
    data,
    getState
    // DO NOT REMoVE THIS COMMENT
    //  ,userSession = null
  ) => {
    if (data.subtype == "chat:user:state") {
      const { unAssignedList, selectedAssignedList } = getState().chatReducer;
      const isSelectedInUnassigned = unAssignedList.some(
        (item) => item.id === selectedAssignedList && selectedAssignedList.id
      );
      if (data.responce && data.responce.success) {
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "profile.status", value: data.responce.status },
          })
        );
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "unAssignedList", value: data.responce.data },
          })
        );
        if (isSelectedInUnassigned) {
          dispatch(
            chatAction.dynamicUpdate({
              data: { key: "selectedAssignedList", value: [] },
            })
          );
        }
      }
    }
    else if (data.subtype === "chat:agent:assist") {
      receiveAgentAssistMessage({ dispatch, data, getState });
    }
    // else if (data.subtype == "chat:fetch:list") {
    //   const {
    //     assistMessageList,
    //     selectedAssignedList,
    //     assistPaginationInfo,
    //   } = getState().chatReducer;
    //   getAssistHistory({ assistMessageList, selectedAssignedList, assistPaginationInfo, data });
    // } 
    else if (data.subtype == "chat:customer:assign") {
      const identifier = data.data.sessionId;
      if (data && data.data && data.data.eventMessage) {
        if (data.data.eventMessage.type === "assign") {
          if (data.data.eventMessage.status === true) {
            /*
            TODO
            *assignList add
            *selectedList update
            */
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: `joinLoading_${identifier}`,
                  value: false,
                },
              })
            );
            const { assignedList, unAssignedList, messageList } = getState().chatReducer;
            const newUnassignedList = removeElementById(
              unAssignedList,
              "identifier",
              data.data.identifier
            );
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: "unAssignedList",
                  value: newUnassignedList,
                },
              })
            );
            // dynamicUpdate({
            //   data: { key: "unAssignedList", value: newUnassignedList },
            // });
            const newAssignedList = removeElementById(
              assignedList,
              "identifier",
              data.data.identifier
            );
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: "assignedList",
                  value: [data.data, ...newAssignedList],
                },
              })
            );
            dispatch(
              chatAction.dynamicUpdate({
                data: { key: "selectedAssignedList", value: data.data },
              })
            );
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: "details.assignScreen",
                  value: true,
                },
              })
            );
            const msg = data.data;
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: `messageList.${data.data.identifier}`,
                  value: [msg, ...(messageList[data.data.identifier] || [])],
                },
              })
            );
            // dynamicUpdate({ data: { key: "details.assignScreen", value: true } });
          } else if (data.data.eventMessage.status === false) {
            dispatch(
              chatAction.dynamicUpdate({
                data: {
                  key: `joinLoading_${identifier}`,
                  value: false,
                },
              })
            );
            if (data.data.eventMessage.uiAction === 'alertOnly') {
              Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
            } else if (data.data.eventMessage.uiAction === "alertAndAction") {
              Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
            } else if (data.data.eventMessage.uiAction === "actionOnly") {
              Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
            } else if (data.data.eventMessage.uiAction === "alertAndRemove") {
              Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
              const { unAssignedList, selectedAssignedList } = getState().chatReducer;
              const newUnassignedList = removeElementById(
                unAssignedList,
                "identifier",
                data.data.identifier
              );
              dispatch(
                chatAction.dynamicUpdate({
                  data: {
                    key: "unAssignedList",
                    value: newUnassignedList,
                  },
                })
              );
              dispatch(
                chatAction.dynamicUpdate({
                  data: { key: "selectedAssignedList", value: {} },
                })
              );
            } else if (data.data.eventMessage.uiAction === "alertAndAdd") {
              Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
              const { assignedList } = getState().chatReducer;
              const newAssignedList = removeElementById(
                assignedList,
                "identifier",
                data.data.identifier
              );
              dispatch(
                chatAction.dynamicUpdate({
                  data: {
                    key: "assignedList",
                    value: [data.data, ...newAssignedList],
                  },
                })
              );
            } else {
              Alert.error("Something went wrong happen.")
            }
          }
        }
      } if (
        data.data &&
        data.data.eventMessage &&
        data.data.eventMessage.type === "assignToOther"
      ) {
        // remove customer from unassigned list
        const { unAssignedList } = getState().chatReducer;
        const newUnAssignedList = removeElementById(
          unAssignedList,
          "identifier",
          data.data.identifier
        );
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "unAssignedList", value: newUnAssignedList },
          })
        );
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "selectedAssignedList", value: {} },
          })
        );
      }
    } else if (data.subtype == "chat:receive:message") {
      receiveMessage({ dispatch, data, getState });
    } else if (data.subtype == "chat:customer:resolve" || data.subType == "chat:customer:close") {
      const { assignedList, messageList, unAssignedList } = getState().chatReducer;
      resolveCustomer({
        identifier: data.data.identifier,
        list: assignedList,
        listData: unAssignedList,
        data,
        messageList,
        getState
      });
    } else if (data.subtype == "chat:customer:dispose") {
      const { disposeList, messageList } = getState().chatReducer;
      disposeCustomer({
        identifier: data.data.identifier,
        list: disposeList,
        data,
        messageList,
        getState
      })
    } else if (data.subtype == "chat:analytics") {
      const identifier = data.data.sessionId;
      if (data.data.eventMessage.type === "analytics" && data.data.eventMessage.subType === "analyticsInProcess") {
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `agentSummaryLoading_${identifier}`, value: true },
          })
        );
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `isAnalyticsEnabled_${identifier}`, value: data && data.data && data.data.isAnalyticsEnabled ? data.data.isAnalyticsEnabled : false }
          })
        )
      } else if (data.data.eventMessage.type === "analytics") {
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `agentSummaryLoading_${identifier}`, value: false },
          })
        );
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `isAnalyticsEnabled_${identifier}`, value: data && data.data && data.data.isAnalyticsEnabled ? data.data.isAnalyticsEnabled : false }
          })
        )
        const summary = data && data.data ? data.data.message.content.analytics : {};
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `agentSummary_${identifier}`, value: summary },
          })
        );
        // const summary = data && data.data ? data.data.message.content.analytics : {};
        dispatch(
          livemonitorAction.setChatSummaryLoading({
            data: false,
          })
        );
        dispatch(
          livemonitorAction.liveSummarySet({
            data: summary,
          })
        );
      }
    } else if (data.subtype == "chat:checklist") {
      const identifier = data.data.sessionId;
      if (data.data.eventMessage.type === "checklist") {
        const checklist = data && data.data ? data.data.checklist : {};
        const checklistArray = parseCheckLists(checklist)
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `chatChecklist_${identifier}`, value: checklistArray },
          })
        );
      }
    }
    else if (data.subtype == "chat:fetch:list") {
      const {
        messageList,
        selectedAssignedList,
        paginationInfo,
        assistMessageList,
        assistPaginationInfo
      } = getState().chatReducer;
      if (
        data &&
        data.responce &&
        data.responce.data && 
        data.responce.data[0] &&
        data.responce.data[0].plateform === "agent-assist") {
        getAssistHistory({ assistMessageList, selectedAssignedList, assistPaginationInfo, data });
      } else {
        getHistory({ messageList, selectedAssignedList, paginationInfo, data });
      }
    } else if (data.subtype == "chat:unassignedlist") {
      // when new customer comes this event will fire
      const { unAssignedList } = getState().chatReducer;
      addNewCustomer({ dispatch, list: unAssignedList, data, getState });
      // dispatch(chatAction.dynamicUpdate({data: { key: "unAssignedList", value: [...unAssignedList, data.data] }}))
    } else if (data.subtype == "chat:agent:current:state") {
      dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "assignedList",
            value:
              (data &&
                data.responce &&
                data.responce.data &&
                data.responce.data.assignList) ||
              [],
          },
        })
      );
      dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "disposeList",
            value:
              (data &&
                data.responce &&
                data.responce.data &&
                data.responce.data.disposeList) ||
              [],
          },
        })
      );
      const assignTeamIds = data && data.responce && data.responce.data && data.responce.data.assignList ? data.responce.data.assignList.map(item => item.teamId) : [];
      const disposeTeamIds = data && data.responce && data.responce.data && data.responce.data.disposeList ? data.responce.data.disposeList.map(item => item.teamId) : [];

      const uniqueTeamIds = [...new Set([...assignTeamIds, ...disposeTeamIds])];

      // const uniqueTeamIds = [...new Set([(data &&
      //   data.responce &&
      //   data.responce.data &&
      //   data.responce.data.assignList.map(item => item.teamId) || [],
      //   data &&
      //   data.responce &&
      //   data.responce.data &&
      //   data.responce.data.disposeList.map(item => item.teamId) || [])])];
      dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "uniqueTeamIds",
            value: uniqueTeamIds || []
          },
        })
      );
      dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "unAssignedList",
            value:
              (data &&
                data.responce &&
                data.responce.data &&
                data.responce.data.unassignList) ||
              [],
          },
        })
      );
      dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "profile.status",
            value:
              (data &&
                data.responce &&
                data.responce.data &&
                data.responce.data.userState) ||
              "offline",
          },
        })
      );

      const assignList = data && data.responce && data.responce.data && data.responce.data.assignList ? data.responce.data.assignList : [];
      const disposeList = data && data.responce && data.responce.data && data.responce.data.disposeList ? data.responce.data.disposeList : [];

      const checklists = [...assignList, ...disposeList].map(item => ({
        identifier: item && item.sessionId ? item.sessionId : "",
        checklist: item && item.checklist ? item.checklist : {},
      }));

      checklists.forEach(item => {
        const checklistArray = parseCheckLists(item && item.checklist ? item.checklist : {});
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: `chatChecklist_${item.identifier}`, value: checklistArray },
          })
        );
      });

    } else if (data.subtype == "customer:reset") {
      const {
        assignedList,
        unAssignedList,
        selectedAssignedList,
      } = getState().chatReducer;

      if (
        selectedAssignedList &&
        selectedAssignedList.identifier == data.data.identifier
      ) {
        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "selectedAssignedList", value: {} },
          })
        );
      }

      const newAssignedList = assignedList.filter(
        (user) => user.identifier !== data.data.identifier
      );
      const newUnAssignedList = unAssignedList.filter(
        (user) => user.identifier !== data.data.identifier
      );

      dispatch(
        chatAction.dynamicUpdate({
          data: { key: "assignedList", value: newAssignedList },
        })
      );
      dispatch(
        chatAction.dynamicUpdate({
          data: { key: "unAssignedList", value: newUnAssignedList },
        })
      );
    } else if (data.subtype == "break:list") {
      if (data.responce && data.responce.data) {
        const { breakList } = getState().globalStateReducer;
        const currentList = breakList || [];
        // Append new data but prevent duplicates by checking _id
        const newItems = data.responce.data.filter(
          (newItem) => !currentList.find((existing) => existing._id === newItem._id)
        );
        dispatch(onlineAction.setBreak({ data: [...currentList, ...newItems] }));
      } else {
        // If there's an explicit failure, we don't clear the list unless necessary, 
        // but for pagination we might just do nothing. Let's keep it safe.
      }
    } else if (data.subtype == "chat:fetch:canned:messages") {
      if (data.responce && data.responce.data) {
        dispatch(
          chatAction.dynamicUpdate({
            data: {
              key: "cannedMessages",
              value: data && data.responce && data.responce.data,
            },
          })
        );
        // dispatch(onlineAction.setBreak({ data: data.responce.data }));
      } else {
        // dispatch(chatAction.dynamicUpdate({ data: [] }));
        dispatch(
          chatAction.dynamicUpdate({
            data: {
              key: "cannedMessages",
              value: [],
            },
          })
        );
      }
    } else if (data.subtype == "user:resents") {
      if (data.responce && data.responce.callList) {
        dispatch(onlineAction.setCallList({ data: data.responce.callList }));
      } else {
        dispatch(onlineAction.setCallList({ data: [] }));
      }
    } else if (data.subtype == "user:teams") {
      if (data.responce) {
        dispatch(profileAction.setTeamList({ teamList: data.responce }));
        if (data.responce && data.responce[0] && data.responce[0].name) {
          let team = data.responce[0];
          dispatch(
            profileAction.setTeam({
              team: { _id: team._id, name: team.name || "" },
            })
          );
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "dialPadTeamName", value: team.name },
            })
          );
        } else {
          dispatch(profileAction.setTeam({ team: { _id: "", name: "" } }));
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "dialPadTeamName", value: "" },
            })
          );
        }
      } else {
        dispatch(profileAction.setTeamList({ data: [] }));
        dispatch(profileAction.setTeam({ team: { _id: "", name: "" } }));
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "dialPadTeamName", value: "" },
          })
        );
      }
    } else if (data.subtype == "user:permission") {
      if (data.accessDefination) {
        dispatch(
          globalAction.dynamicUpdate({
            data: {
              key: "accessDefination",
              value: data.accessDefination,
            },
          })
        );
      }
    } else if (data.subtype == "user:Update") {
      if (data.responce && !data.responce.errorFound) {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "currentUser", value: data.responce },
          })
        );
      } else {
        // dispatch(profileAction.dynamicUpdate({ data: [] }));
      }
    } else if (data.subtype == "contact-list:detail") {
      if (data.responce) {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "custInfo", value: data.responce },
          })
        );
      } else {
        // dispatch(profileAction.dynamicUpdate({ data: [] }));
      }
    } else if (data.subtype == "customer:comments") {
      if (data.responce) {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "comments", value: data.responce },
          })
        );
      } else {
        // dispatch(profileAction.dynamicUpdate({ data: [] }));
      }
    } else if (data.subtype == "team:preview:count") {
      if (data.responce.count) {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "previewCount", value: data.responce.count },
          })
        );
      } else {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "previewCount", value: 0 },
          })
        );
      }
    } else if (
      data.subtype == "team:preview:lead" ||
      data.subtype == "team:preview:skip"
    ) {
      if (
        data.subtype == "team:preview:skip" &&
        data.responce &&
        typeof data.responce.newLead != "undefined" &&
        data.responce.newLead == false
      ) {
        return;
      }
      if (
        data.responce &&
        data.responce.data &&
        data.responce.data.info &&
        data.responce.data.info.phone_number
      ) {
        let customerName = data.responce.data.info.name || "",
          customerPhone = data.responce.data.info.phone_number || "";

        dispatch(callAction.setCallCustomerName({ data: customerName }));
        dispatch(callAction.setCallCustomerNumber({ data: customerPhone }));

        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "previewCount", value: data.responce.count },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "custInfo", value: data.responce.data },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: {
              key: "previewTimer",
              value: data.responce.info.previewTimer || 60,
            },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "previewTeam", value: data.responce.info },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: {
              key: "previewStartTimer",
              value: parseInt(new Date() / 1000),
            },
          })
        );
        setTimeout(() => {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isPreviewLoad", value: false },
            })
          );
        }, 200);
      } else {
        // if( data.responce && data.responce.error ){
        // Alert.error(`[Preview]${data.responce.error}`);
        // } else {
        // Alert.error(
        //   `You are not mapped in process or no lead present in campaign`
        // );
        Alert.error("This Contact is on the Do Not Call List")
        // }
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "isPreviewLoad", value: false },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "isPreviewDial", value: false },
          })
        );
        let message = {
          type: "stateHandler",
          state: "offline",
          subState: "",
          stateInfo: "",
        };
        messageService.emitSocketMessage("message-processor", message);
      }
    } else if (data.subtype == "team:tag:list") {
      if (data.responce && data.responce.data && data.responce.data.length) {
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "tagsList", value: data.responce.data },
          })
        );
      } else {
        dispatch(
          globalAction.dynamicUpdate({
            data: {
              key: "tagsList",
              value: [
                {
                  name: "No Tags Found",
                  _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
                },
              ],
            },
          })
        );
      }
    } else if (data.subtype == "message:team:tag:list") {
      if (data.responce && data.responce.data && data.responce.data.length) {
        // Get current messageTagsList from state
        const { messageTagsList } = getState().chatReducer;
        const currentTagsList = messageTagsList || [];

        // Append new response data to existing list
        const updatedTagsList = [
          ...currentTagsList,
          ...data.responce.data, // Append new data from the response
        ];

        // Store the whole response (instead of just data)
        const updatedResponseList = [
          ...currentTagsList,
          data.responce
        ];

        dispatch(
          chatAction.dynamicUpdate({
            data: { key: "messageTagsList", value: updatedResponseList },
          })
        );
      } else {
        dispatch(
          chatAction.dynamicUpdate({
            data: {
              key: "messageTagsList",
              value: [
                {
                  name: "No Tags Found",
                  _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
                },
              ],
            },
          })
        );
      }
    }
    else if (data.subtype == "transfer:list") {
      if (data.responce && data.responce.data) {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : data.responce.data} }));
        liveMonitor.updateTransferList(dispatch, data.responce.data);
      } else {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : []} }));
        liveMonitor.updateTransferList(dispatch, []);
      }
    } else if (data.subtype == "user:live:monitor") {
      if (data.responce) {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : data.responce.data} }));
        liveMonitor.updateLiveData(data.responce);
      } else {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : []} }));
        liveMonitor.updateLiveData({});
      }
    } else if (data.subType == "GLOBAL_DNC" || data.subType == "TEAM_DNC") {
      let message = data.message || `This Contact is on the Do Not Call List`;
      Alert.error(message);
      dispatch(
        globalAction.dynamicUpdate({
          data: { key: "callHandlingLoader", value: false },
        })
      );
      try {
        clearTimeout(global.__callBtn);
      } catch (error) { }
    } else if (data.state == "INBOUND_CALL" && data.callType == "inboundCall") {
      liveMonitor.inboundHandle(dispatch, data);
    } else if (data.subtype == "callAndConnect") {
      if (data.responce && data.responce.errorFound) {
        let message = `We are not able to dial this number`;
        if (data.responce.error && data.responce.error.message) {
          message = data.responce.error.message;
        }
        Alert.error(message);
      }
      try {
        clearTimeout(global.__callBtn);
      } catch (error) { }
      dispatch(
        globalAction.dynamicUpdate({
          data: { key: "callHandlingLoader", value: false },
        })
      );
      // liveMonitor.inboundHandle(dispatch, data);
    } else if (data.subtype == "bridgeCall") {
      if (data.responce && data.responce.errorFound) {
        let message = `We are not able to dial this number`;
        if (data.responce.error && data.responce.error.message) {
          message = data.responce.error.message;
        }
        Alert.error(message);
      } else {
        if (
          data.responce.info &&
          data.responce.info.data &&
          data.responce.info.data.dtmf
        ) {
          dispatch(
            globalAction.dynamicUpdate({
              data: {
                key: "bridgeStateOTP",
                value: data.responce.info.data.dtmf,
              },
            })
          );
        } else {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "bridgeStateOTP", value: "- - - -" },
            })
          );
        }
      }
    } else if (data.subtype == "callback-notification") {
      const { state } = getState().globalStateReducer;
      let currentState = state.State || "";
      if (
        data.responce &&
        data.responce.detail &&
        data.responce.detail.detail
      ) {
        if (currentState == "online") {
          let message = {
            type: "stateHandler",
            state: "callback",
            subState: "",
            stateInfo: "",
          };
          messageService.emitSocketMessage("message-processor", message);
        }
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "cbTab", value: "notify" },
          })
        );
        dispatch(
          globalAction.dynamicUpdate({ data: { key: "cbNotify", value: true } })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: { key: "cbInfo", value: data.responce || {} },
          })
        );
        try {
          let extra = data.responce.detail.detail || {};
          let team = extra.team || {};
          let campaign = extra.campaign || {};
          let leadSet =
            extra.custInfo && extra.custInfo.objInfo
              ? extra.custInfo.objInfo
              : {};
          dispatch(
            globalAction.dynamicUpdate({
              data: {
                key: "previewTeam",
                value: {
                  teamId: team.id || "",
                  teamName: team.name || "",
                  leadsetId: leadSet._id || "",
                  leadsetName: team.name || "",
                  campaignId: campaign.id || "",
                  campaignName: campaign.name || "",
                },
              },
            })
          );
        } catch (error) { }
      }
    } else if (data.subtype == "notification:list") {
      const { teamList } = getState().profileStateReducer;
      let numberMask = {};
      try {
        teamList.map((e) => {
          numberMask[e._id] = e.numberMasking || false;
        });
      } catch (error) { }
      // let phone_number = el.customerNo || "";
      // if(el.customerNo){
      //   phone_number = callTeam && callTeam.id && numberMask[`${callTeam.id}`]===true?commonManager.maskText(el.customerNo):el.customerNo
      // }
      let count = 0;
      let list = [];
      if (data.responce) {
        let cbList = data.responce.data || [];
        count = data.responce.count || "";
        for (const el of cbList) {
          let team = el.detail && el.detail.team ? el.detail.team : {};
          if (team.id || team._id) {
            let date = el.dateTime || "";
            let phone_number = el.customerNo || "";
            try {
              date = moment(el.dateTime).format("YYYY-MM-DD HH:mm:ss");
              // date = moment(el.dateTime).calendar()
              phone_number =
                numberMask[`${team.id}`] === true
                  ? commonManager.maskText(el.customerNo)
                  : el.customerNo;
            } catch (error) {
              date = el.dateTime;
            }
            let callInfo = {
              info: el,
              message: team.name || "",
              extraMessage: team.name || "",
              phoneNumber: el.customerNo || "",
              name:
                el.customerName && el.customerName != "No Name"
                  ? el.customerName
                  : phone_number,
              teamId: team.id || team._id || "",
              time: date,
              type: "manual",
            };
            list.push(callInfo);
          }
        }
      }
      dispatch(
        globalAction.dynamicUpdate({ data: { key: "cbCnt", value: count } })
      );
      dispatch(
        globalAction.dynamicUpdate({ data: { key: "cbList", value: list } })
      );
      dispatch(
        globalAction.dynamicUpdate({
          data: { key: "cbListLoading", value: false },
        })
      );
      // const { state } = getState().globalStateReducer;
      // dispatch(globalAction.dynamicUpdate({ data  : {"key":"cbList",value : true } }));
    } else if (data.subtype == "notification:count") {
      let count = 0;
      if (data.responce) {
        count = data.responce.count || "";
      }
      dispatch(
        globalAction.dynamicUpdate({ data: { key: "cbCnt", value: count } })
      );
      // const { state } = getState().globalStateReducer;
      // dispatch(globalAction.dynamicUpdate({ data  : {"key":"cbList",value : true } }));
    } else if (
      data.subType == "conversation" &&
      data.state == "BOT_TRANSCRIPTION"
    ) {
      const transcription = data && data.data ? data.data : [];
      if (dispatch) {
        dispatch(
          callAction.setTranscription({
            data: transcription,
          })
        );
      }
    } else if (
      data.subType == "monitorAnalytics" &&
      data.state == "BOT_TRANSCRIPTION"
    ) {
      const summary = data && data.data ? data.data : {};
      if (dispatch) {
        dispatch(
          callAction.setSummary({
            data: summary,
          })
        );
        dispatch(
          callAction.setSummaryLoading({
            data: false,
          })
        );
      }
    } else if (
      data.subType == "conversation" ||
      data.state == "LIVE_BOT_TRANSCRIPTION"
    ) {
      const transcriptionUpdate = data && data.data ? data.data : [];
      dispatch(
        callAction.updateTranscription({
          data: transcriptionUpdate,
        })
      );
    } else if (
      data.subType == "analytics" ||
      data.state == "LIVE_CONVERSATON_ANALYTICS"
    ) {
      const summary = data && data.data ? data.data : {};
      dispatch(
        callAction.setSummary({
          data: summary,
        })
      );
    } else if (data.subtype == "user:live:monitor:message") {
      if (data) {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : data.responce.data} }));
        liveMonitor.updateLiveChatData(data.responce);
      } else {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : []} }));
        liveMonitor.updateLiveChatData({});
      }
    }
    else if (data.subtype == "user:live:monitor:message:update") {
      if (data) {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : data.responce.data} }));
        liveMonitor.updateNewLiveChatData(data.data);
      } else {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : []} }));
        liveMonitor.updateNewLiveChatData({});
      }
    }
    else if (data.subtype == "live:monitor:chat:stats") {
      if (data) {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : data.responce.data} }));
        liveMonitor.updateLiveChatStatsData(data.responce);
      } else {
        // dispatch(globalAction.dynamicUpdate({ data  : {"key":"transferList",value : []} }));
        liveMonitor.updateLiveChatStatsData({});
      }
    }
    else if (data.subtype == "user:live:monitor:message:bargin:old") {
      const liveTranscription = data && data.data ? data.data : [];
      dispatch(
        livemonitorAction.liveTranscriptionSet({
          data: liveTranscription,
        })
      );
    }
    else if (data.subtype == "user:live:monitor:message:bargin") {
      const liveTranscriptionUpdate = data && data.data ? data.data : [];
      dispatch(
        livemonitorAction.liveTranscriptionUpdate({
          data: liveTranscriptionUpdate,
        })
      );
    }
    else if (
      data.subType == "checklist" &&
      data.state == "LIVE_CONVERSATON_CHECKLIST"
    ) {
      const checklist = data && data.data ? data.data : [];
      const checklistArray = parseCheckLists(checklist)
      if (dispatch) {
        dispatch(
          callAction.setCallChecklist({
            data: checklistArray,
          })
        );
      }
    }
    // DO NOT REMOVE THIS COMMENT
    // else if ( data.subtype == "admin-state-handler" ) {
    // 	if (userSession && userSession.extraData && userSession.extraData.call1) {
    // 		if (userSession.extraData.call1.from) {
    // 			dispatch(
    // 				globalAction.dynamicUpdate({
    // 					data: {
    // 						key: "callInboundNumber",
    // 						value: userSession.extraData.call1.from,
    // 					},
    // 				})
    // 			);
    // 		}
    // 		if (userSession.extraData.call1.callerId) {
    // 			dispatch(
    // 				globalAction.dynamicUpdate({
    // 					data: {
    // 						key: "callerId",
    // 						value: userSession.extraData.call1.callerId,
    // 					},
    // 				})
    // 			);
    // 		}
    // 	}
    // }
  },
  tagProcess: (dispatch, type, data) => {
    // sip.destroyPhone();
    messageService.emitSocketMessage(type, data);
  },
  destroyPhone: messageService.destroyPhone,
  answerCall: messageService.answerCall,
  rejectCall: messageService.rejectCall,
  registerUser: (dispatch, type, data, getState) => {
    const { cbNotify } = getState().globalStateReducer;
    let config = data;
    let nextState = cbNotify ? "callback" : "online";
    if (config.sipConfig) {
      let sipConfig = config.sipConfig;
      this.sipConfig = {
        authorizationUsername: sipConfig.username,
        authorizationPassword: sipConfig.password,
        displayName: sipConfig.username,
        contactName: sipConfig.username,
        userAgentString: "",
        traceSip: false,
        register: true,
        uri: UserAgent.makeURI(`sip:${sipConfig.username}@${sipConfig.domain}`),
        transportOptions: {
          server: sipConfig.url,
        },
        password: sipConfig.password,
      };

      let options = {
        initial: () => { },
        registered: () => {
          if (config.forceOnline) {
            let message = {
              type: "stateHandler",
              state: nextState,
              subState: "",
              stateInfo: "",
            };
            messageService.emitSocketMessage("message-processor", message);
          } else {
          }
        },
        terminated: () => { },
        unregistered: () => {
          let message = {
            type: "stateHandler",
            state: "offline",
            subState: "",
            stateInfo: "",
          };
          messageService.emitSocketMessage("message-processor", message);
        },
      };
      sip.initPhone(this.sipConfig, options);
    } else {
    }
  },
  fetchMoreMessage: async (currentMessageData) => {
    // const response = await apiV1().get(
    //   `/messages/${currentMessageData.channelId}`,
    //   {
    //     params: {
    //       offset: currentMessageData.offset
    //     }
    //   }
    // );
    // return response;
  },
  liveMonitorProcess: async (dispatch, data) => {
    liveMonitor.process(dispatch, data);
  },
};



// WEBPACK FOOTER //
// src/dialpad/service/message.service.js